import React from 'react';

const Spinner = ({ label }) => (
	<div className="flex w-full flex-col items-center gap-[12px] py-[24px]">
		<div className="h-[32px] w-[32px] animate-spin rounded-full border-[3px] border-pay-line border-t-pay-purple" />
		{label ? <p className="text-[13px] text-pay-muted">{label}</p> : null}
	</div>
);

export default Spinner;
